import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { PrimeTemplate } from "primeng-v17/api";
import { DropdownModule } from "primeng-v17/dropdown";
import { AppendToBodyDirective } from "../../shared/primeng/append-to-body/append-to-body.directive";
import { DropdownEditableColumnAutoFocusDirective } from "../../shared/primeng/dropdown-editable-column-auto-focus/dropdown-editable-column-auto-focus.directive";
import { DropdownHideFixDirective } from "../../shared/primeng/dropdown-hide-fix/dropdown-hide-fix.directive";
import { DropdownOptionsDirective } from "../../shared/primeng/dropdown-options/dropdown-options.directive";
import { DropdownPrePopulateSingleOptionDirective } from "../../shared/primeng/dropdown-pre-populate-single-option/dropdown-pre-populate-single-option.directive";
import { DropdownReadonlyFixDirective } from "../../shared/primeng/dropdown-readonly-fix/dropdown-readonly-fix.directive";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiOrganizationSwitchComponent } from "./new-ui-organization-switch.component";

@Component({
  selector: "app-organization-switch",
  templateUrl: "./organization-switch.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateDirective,
    DropdownModule,
    AppendToBodyDirective,
    DropdownEditableColumnAutoFocusDirective,
    DropdownHideFixDirective,
    DropdownOptionsDirective,
    DropdownPrePopulateSingleOptionDirective,
    DropdownReadonlyFixDirective,
    PrimeTemplate,
    NgIf,
  ],
})
export class OrganizationSwitchComponent extends NewUiOrganizationSwitchComponent {}
